import React, { useEffect, useRef, useState } from "react";
import {
  useAuth,
  useI18N,
  usePostAddMapperNotes,
  VenueDetailsBySlugResponse,
} from "common/hooks";

import Loader from "@/components/common/Loader";
import { useCustomToast } from "@/hooks/useCustomToast";
import { XIcon } from "lucide-react";
import { Textarea } from "@/shadcn/components/ui/textarea";
import WideButton from "@/components/common/WideButton";
import { useDarkMode } from "@/hooks/useDarkMode";
import Checkbox from "@/components/common/Checkbox";
import AnalyticsService from "@/services/analytics";
import SelectDropDown from "@/components/common/SelectDropDown";

function AreaDetailsNotes(props: {
  venueDetailsReponse: VenueDetailsBySlugResponse;
  onClose: () => void;
  mode: string; 
}) {
  const i18n = useI18N();
  const { user } = useAuth();

  const showToast = useCustomToast();

  const [notes, setNotes] = useState("");
  const { data: mutateResult, error, status, mutate } = usePostAddMapperNotes();
  const [selectedOption, setSelectedOption] = useState(0);
  const noteRef = useRef(null);
  const isDark = useDarkMode();
  const [returnOnDate, setReturnOnDate] = useState("");



  return (
    <>
      <section
        className="flex flex-col bg-white dark:bg-primary-900 rounded-xl h-[calc(100vh-150px)] md:h-[calc(100vh-200px)] overflow-y-auto"
        role="none"
      >
        {status === "pending" && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-[250px] z-50">
            <Loader />
          </div>
        )}

        <header className="py-4 min-h-14 flex items-center justify-center text-center px-6 border-b border-primary-200 dark:border-primary-150 vsticky top-0">
          <h1
            className="desktop-h1-xxsmall-bold text-center text-primary-800 dark:text-primary-150"
            tabIndex={0}
          >
            {i18n.get("priorityLevels")}
          </h1>
          <button
            onClick={props.onClose}
            className="absolute top-4 left-4"
            aria-label="Close modal"
          >
            <XIcon color={isDark ? "#A39FE8" : "#352FC3"} />
          </button>
        </header>

        <div
          aria-label="Modal Content"
          className="flex-grow overflow-y-auto py-3 px-3"
          role="none"
        >
          <div className="self-stretch px-1 pt-2 flex-col justify-start items-center gap-2 flex">            
            <div className="self-stretch   rounded-lg justify-start items-center gap-8 inline-flex">
              <div className="mb-2">
                <div className="flex flex-col mt-1">
                  <div className="flex items-center gap-2">
                    <div className="flex-1">
                      <div className="flex flex-col gap-4">
                        {(props.mode === 'mappernote' 
                          ? props.venueDetailsReponse.details.businessNotesActions 
                          : props.venueDetailsReponse.details.businessNotesActionsVenueNotes
                        )?.map(
                          (option) => {
                            const sections = option.description.split("##");
                            const titleParts = sections[0].split(":");
                            const mainTitle = titleParts[0].trim();
                            const subtitle = titleParts[1]?.trim();
                            const description = sections[1];
                            return (
                              <div 
                                key={option.id} 
                                className="border-b border-neutral-200 dark:border-neutral-600 px-5 py-4"
                              >
                                <p className="paragraph-medium-semibold text-primary-800 dark:text-primary-150">
                                  {mainTitle}
                                </p>
                                {subtitle && (
                                  <p className="paragraph-small-regular text-neutral-700 dark:text-neutral-300 mt-1 mb-2">
                                    {subtitle}
                                  </p>
                                )}
                                {description && (
                                  <div className="flex gap-2">
                                    <span className="text-neutral-700 dark:text-neutral-300">•</span>
                                    <p className="paragraph-small-regular text-neutral-700 dark:text-neutral-300">
                                      {description}
                                    </p>
                                  </div>
                                )}
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>                  
                  </div>
                </div>

              </div>
            </div>

            <div className="md:hidden border w-full border-primary-150 dark:border-neutral-400 mt-1 h-[1px]"></div>

            
          </div>
        </div>

       
      </section>
    </>
  );
}

export default AreaDetailsNotes;
